
import SplashPage from '@scoir/splash-page'

import { getParams } from 'common/click-tracking-params'

import artwork from './Splash-Home.png'

const DashboardSplashPage = () => {
  const params = getParams('Create Free Account', 'Page')

  return (
    <SplashPage
      title="Take the College Match Quiz"
      subtitle="Take 2 minutes to find your best-fit colleges."
      body="Wondering which college you should go to? Share your preferences and we'll match you with colleges and customize your discovery experience. Your personal data is never shared with colleges."
      artwork={artwork}
      artworkProps={{ alt: 'Sign in to view College Match Quiz' }}
      buttonText="Create Free Account"
      buttonHref={`/signup?${params}`}
    />
  )
}

export default DashboardSplashPage
